var map = {
	"./hl/0.png": "0917",
	"./hl/1.png": "f2dd",
	"./hl/2.png": "fbb0",
	"./hl/3.png": "2cde",
	"./hl/4.png": "8617",
	"./hl/5.png": "f6a2",
	"./hl/6.png": "1dce",
	"./hl/7.png": "24e8",
	"./hl/8.png": "537a",
	"./hl/9.png": "0ae4",
	"./home_possession.png": "5564",
	"./hr/0.png": "feb5",
	"./hr/1.png": "30ff",
	"./hr/2.png": "b03e",
	"./hr/3.png": "ca6b",
	"./hr/4.png": "cb2b",
	"./hr/5.png": "1970",
	"./hr/6.png": "31ad",
	"./hr/7.png": "0a5f",
	"./hr/8.png": "1266",
	"./hr/9.png": "2cf9",
	"./visitor_possession.png": "95c5",
	"./vl/0.png": "6596",
	"./vl/1.png": "8e0d",
	"./vl/2.png": "12e2",
	"./vl/3.png": "a3ca",
	"./vl/4.png": "0090",
	"./vl/5.png": "c6eb",
	"./vl/6.png": "54af",
	"./vl/7.png": "1139",
	"./vl/8.png": "99a5",
	"./vl/9.png": "8b30",
	"./vr/0.png": "c9f5",
	"./vr/1.png": "27db",
	"./vr/2.png": "f40e",
	"./vr/3.png": "fbfc",
	"./vr/4.png": "daec",
	"./vr/5.png": "3fc7",
	"./vr/6.png": "a8cb",
	"./vr/7.png": "24a5",
	"./vr/8.png": "370d",
	"./vr/9.png": "c09d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1913";